export default "__VITE_ASSET__231fe6ad__"